import { FC } from 'react'
import { Tag as AntdTag } from 'antd'
import { BackArrow } from '../../../ui'
import { getStatus } from '../../../Profile/components'
import PowerTypeTag from '../PowerTypeTag/PowerTypeTag'
import style from './style.m.less'

interface IHeaderBlock {
    label?: string
    energyType?: string
    energyTypeLocalized?: string
    status?: number
    tsoConfirmed?: boolean
    gpConfirmed?: boolean
    showConfirmedTag?: boolean
}

const HeaderBlock: FC<IHeaderBlock> = ({
    label,
    energyType,
    energyTypeLocalized,
    status,
    showConfirmedTag,
    tsoConfirmed,
    gpConfirmed,
}) => {
    return (
        <div className={style.headerMain}>
            <div className={style.headerBlock}>
                <BackArrow />
                <div className={style.mainHeader}>{label}</div>
            </div>
            <div className={style.tagsBlock}>
                {energyType && (
                    <PowerTypeTag customStyle={{ marginLeft: '16px' }} value={energyType}>
                        {energyTypeLocalized}
                    </PowerTypeTag>
                )}
                {getStatus(status)}
                {showConfirmedTag && (
                    <AntdTag className={style.statusTag}>
                        {tsoConfirmed || gpConfirmed
                            ? 'Связь подтверждена'
                            : 'Связь не подтверждена'}
                    </AntdTag>
                )}
            </div>
        </div>
    )
}

export default HeaderBlock
